import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  @Input() mapControls;
  @Input() showSearchBar = false;
  @Input() showCurrentLocationBtn;
  @Input() isModalClosed;
  @Input() isMarkerDraggable = false;
  @Input() showMarker = true;
  @Input() showAddressSection = false;
  @Input() showCircles = false;
  @Input() address = '';
  @Input() mapView;
  @Output("eventHandle") eventHandle = new EventEmitter();
  @ViewChild('search') searchElementRef: ElementRef;
  @ViewChild('showCurrentPosition') currentPosElementRef: ElementRef;
  @ViewChild('myGoogleMap') map!: GoogleMap;
  searchText;
  options: google.maps.MapOptions = {
    zoomControl: true,
    disableDefaultUI: true,
    fullscreenControl: true,
    disableDoubleClickZoom: true,
    mapTypeControl: true,
    scrollwheel: true
    // mapTypeId: 'hybrid',
    // maxZoom:this.maxZoom,
    // minZoom:this.minZoom,
  };

  center!: google.maps.LatLngLiteral;
  searchState = false;
  mapPoint;
  mapAddress = [];
  zoneCircles = [];
  zoneDots = [];
  markers: any;
  zoom = 14;
  constructor(
    private ngZone: NgZone,
  ) { }

  ngOnInit(): void {
  }


  ngAfterViewInit(): void {
    let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
    // this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(
    //   this.searchElementRef.nativeElement
    // );
    if (this.currentPosElementRef) {
      this.map.controls[google.maps.ControlPosition.RIGHT_CENTER].push(
        this.currentPosElementRef.nativeElement
      );
    }
    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        //get the place result
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        //verify result
        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        //set latitude, longitude and zoom
        this.mapPoint.lat = place.geometry.location.lat();
        this.mapPoint.long = place.geometry.location.lng();
        this.searchState = true;
        this.center = {
          lat: this.mapPoint.lat,
          lng: this.mapPoint.long,
        };
        this.addMarker();
        if (this.mapControls?.circles?.length > 0 && this.showCircles) {
          this.addCircles();
        }
        this.getAddress(this.mapPoint.lat, this.mapPoint.long, false)
      });
    });
  }
  ngOnChanges() {
    if (this.isModalClosed) {
      this.searchText = '';
    }
    if (this.mapControls) {
      this.mapPoint = this.mapControls?.mapPoint;
      if (this.mapPoint?.lat == null) {
        this.mapPoint.lat = parseFloat(localStorage.getItem('schoolLat'))
        this.mapPoint.long = parseFloat(localStorage.getItem('schoolLong'))
      }
      this.center = {
        lat: this.mapPoint.lat,
        lng: this.mapPoint.long,
      };
      this.addMarker()
      this.mapAddress = this.mapControls.mapaddress ? this.mapControls.mapaddress : [];
      if (this.mapControls?.circles?.length > 0 && this.showCircles) {
        this.addCircles();
      }
      this.getAddress(this.mapPoint.lat, this.mapPoint.long, false)
    }
  }


  addMarker() {
    this.markers = [];
    this.markers.push({
      position: {
        lat: this.center.lat,
        lng: this.center.lng
      },
      options: { draggable: this.isMarkerDraggable },
    });
  }
  addCircles() {
    this.zoneCircles = [];
    this.zoneDots = [];
    this.zoneCircles.push({
      center: {
        lat: this.mapControls?.circles[0]?.lat,
        lng: this.mapControls?.circles[0]?.long
      },
      options: {
        draggable: false,
        fillColor: this.mapControls?.circles[0]?.color,
        strokeWeight: 0,
      },
      radius: this.mapControls?.circles[0]?.radius
    });

    this.zoneDots.push({
      position: {
        lat: this.mapControls?.circles[0]?.lat,
        lng: this.mapControls?.circles[0]?.long
      },
      options: {
        draggable: false,
        icon: '../../../assets/images/Ellipse 591.svg'
      },
    });
  }

  getAddress(latitude, longitude, getAddress = true) {
    if (this.mapView !== 'add-student' && this.mapView !== 'add-parent') {
      return;
    }
    
    const schoolLat = localStorage.getItem('schoolLat');
    const schoolLong = localStorage.getItem('schoolLong');
    const isSchoolLocation = latitude == schoolLat && longitude == schoolLong;

    if (!getAddress && isSchoolLocation) {
      return;
    }

    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
      if (status === 'OK') {
        if (results[0]) {
          this.zoom = 17;
          this.address = results[0].formatted_address;
          this.eventHandle.emit({
            type: "updateAdress",
            data: this.address,
            lat: latitude,
            lng: longitude
          });
        } else {
          console.log('No results found');
        }
      } else {
        console.log('Geocoder failed due to: ' + status);
      }
    });
  }

  onMouseClicked(data) {
    this.eventHandle.emit({
      type: "pointClicked",
      data: data
    });
  }
  mapClicked(event) {
    this.eventHandle.emit({
      type: "mapClicked",
      data: {
        lat: event.latLng.lat(),
        long: event.latLng.lng()
      }
    });
  }

  getCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.mapPoint.lat = position.coords.latitude;
        this.mapPoint.long = position.coords.longitude;
        this.searchState = true;
        this.searchText = '';
        this.center = {
          lat: this.mapPoint.lat,
          lng: this.mapPoint.long,
        };
        this.showMarker = true;
        this.addMarker();
        if (this.showCircles) {
          this.addCircles();
        }
        this.getAddress(this.mapPoint.lat, this.mapPoint.long)
      });
    }
  }

  markerDragEnd($event: any) {
    this.searchText = '';
    this.getAddress($event.latLng.lat(), $event.latLng.lng());
  }

  deleteAdress() {
    this.address = '';
    this.eventHandle.emit({
      type: "updateAdress",
      data: this.address,
      lat: null,
      lng: null
    });
  }
}
